export default __webpack_public_path__ + "static/banner-pattern-2-716e5ac0f7d030b796236ce852547e16.png";